import * as ProductLines from 'self-service-api/constants/ProductLines';
import * as EnrolledProductLines from 'self-service-api/constants/EnrolledProductLines';
import { ENTERPRISE, STARTER } from '../routing/Tabs';
const CaseStudiesConfig = {
  [ProductLines.MARKETING]: {
    [STARTER]: [{
      caseStudyKey: 'canceriq',
      href: 'https://www.hubspot.com/case-studies/canceriq',
      logo: 'https://www.hubspot.com/hubfs/Fergals/Case%20Study%20Logos/1_S8CLgCauap79DEu6IXL0Hg.png'
    }, {
      caseStudyKey: 'checkwriters',
      href: 'https://www.hubspot.com/case-studies/checkwriters',
      logo: 'https://www.checkwriters.com/files/structure_2021/images/logo.svg'
    }],
    [ENTERPRISE]: [{
      caseStudyKey: 'fundraise-up',
      href: 'https://www.hubspot.com/case-studies/fundraise-up',
      logo: 'https://www.hubspot.com/hubfs/Fundraise%20Up%20Logo%20(Color%2c%20Hor).svg'
    }, {
      caseStudyKey: 'loom',
      href: 'https://www.hubspot.com/case-studies/loom',
      logo: 'https://www.hubspot.com/hubfs/Loom-Logo.png'
    }]
  },
  [ProductLines.SALES]: {
    [STARTER]: [{
      caseStudyKey: 'ceros',
      href: 'https://www.hubspot.com/case-studies/ceros',
      logo: 'https://53.fs1.hubspotusercontent-na1.net/hubfs/53/Case_Studies/Ceros/Ceros_Digital_Magazine.png'
    }, {
      caseStudyKey: 'australian-training-colleges',
      href: 'https://www.hubspot.com/case-studies/australian-training-colleges',
      logo: 'https://www.hubspot.com/hubfs/_logo%20(500%20x%20250%20px).png'
    }],
    [ENTERPRISE]: [{
      caseStudyKey: 'teamwork',
      href: 'https://www.hubspot.com/case-studies/teamwork.com',
      logo: 'https://www.hubspot.com/hubfs/1200px-Teamwork-logo.svg-1.png'
    }, {
      caseStudyKey: 'm-square-media',
      href: 'https://www.hubspot.com/case-studies/m-square-media',
      logo: 'https://www.hubspot.com/hubfs/MSM%20Logo.png'
    }]
  },
  [ProductLines.SERVICE]: {
    [STARTER]: [{
      caseStudyKey: 'roofmaxx',
      href: 'https://www.hubspot.com/case-studies/roofmaxx',
      logo: 'https://6044336.fs1.hubspotusercontent-na1.net/hubfs/6044336/Roofmaxx_logo_full%20color%20(3).png'
    }, {
      caseStudyKey: 'convierte-más',
      href: 'https://www.hubspot.com/case-studies/convierte-m%C3%A1s',
      logo: 'https://conviertemas.com/wp-content/uploads/2020/10/logo-master.svg'
    }],
    [ENTERPRISE]: [{
      caseStudyKey: 'resellerratings',
      href: 'https://www.hubspot.com/case-studies/resellerratings',
      logo: 'https://www.hubspot.com/hubfs/Reseller%20Ratings-2.svg'
    }, {
      caseStudyKey: 'sandler-training',
      href: 'https://www.hubspot.com/case-studies/sandler-training',
      logo: 'https://www.hubspot.com/hubfs/case%20study%20logos/Sandler%20S%C2%AE%202C%20(1)%20(2).png'
    }]
  },
  [ProductLines.CMS]: {
    [STARTER]: [{
      caseStudyKey: 'kuntze',
      href: 'https://www.hubspot.com/case-studies/kuntze',
      logo: 'https://www.kuntzeusa.com/hubfs/Kuntze_August2019/Image/logo.svg'
    }, {
      caseStudyKey: 'classpass',
      href: 'https://www.hubspot.com/case-studies/classpass',
      logo: 'https://www.hubspot.com/hubfs/Fergals/Case%20Study%20Logos/ClassPass%20Logo.png'
    }],
    [ENTERPRISE]: [{
      caseStudyKey: 'carprousa',
      href: 'https://www.hubspot.com/case-studies/carprousa.com',
      logo: 'https://www.hubspot.com/hubfs/case%20study%20logos/Case%20Study%20Logo%20(22).png'
    }, {
      caseStudyKey: 'lucidpress',
      href: 'https://www.hubspot.com/case-studies/carprousa.com',
      logo: 'https://www.hubspot.com/hubfs/unnamed-Nov-24-2021-02-50-52-78-AM.png',
      price: 77000
    }]
  },
  [ProductLines.OPERATIONS]: {
    [STARTER]: [{
      caseStudyKey: 'askcody',
      href: 'https://www.hubspot.com/case-studies/askcody',
      logo: 'https://www.askcody.com/hubfs/AskCody%20Optimized%20images/askcody-logo.png'
    }, {
      caseStudyKey: 'thomas-witt-consulting',
      href: 'https://www.hubspot.com/case-studies/thomas-witt-consulting',
      logo: 'https://www.hubspot.com/hubfs/Fergals/Case%20Study%20Logos/Thomas%20Witt%20Consulting%20Logo.png'
    }],
    [ENTERPRISE]: [{
      caseStudyKey: 'casio',
      href: 'https://www.hubspot.com/case-studies/casio',
      logo: 'https://www.hubspot.com/hubfs/Fergals/Casio.png'
    }, {
      caseStudyKey: 'suzuki',
      href: 'https://www.hubspot.com/case-studies/suzuki',
      logo: 'https://www.hubspot.com/hubfs/Fergals/Case%20Study%20Logos/Suzuki%20Logo.png'
    }]
  },
  [EnrolledProductLines.COMMERCE]: {
    [STARTER]: [{
      caseStudyKey: 'nutritional-coaching-institute-hubspot-payments',
      href: 'https://www.hubspot.com/case-studies/nutritional-coaching-institute-hubspot-payments',
      logo: 'https://www.hubspot.com/hubfs/NCI-3.png'
    }, {
      caseStudyKey: 'apps-without-code-hubspot-payments',
      href: 'https://www.hubspot.com/case-studies/apps-without-code-hubspot-payments',
      logo: 'https://www.hubspot.com/hubfs/AWOC.png'
    }],
    [ENTERPRISE]: [{
      caseStudyKey: 'nutritional-coaching-institute-hubspot-payments',
      href: 'https://www.hubspot.com/case-studies/nutritional-coaching-institute-hubspot-payments',
      logo: 'https://www.hubspot.com/hubfs/NCI-3.png'
    }, {
      caseStudyKey: 'apps-without-code-hubspot-payments',
      href: 'https://www.hubspot.com/case-studies/apps-without-code-hubspot-payments',
      logo: 'https://www.hubspot.com/hubfs/AWOC.png'
    }]
  }
};
export const getCaseStudies = ({
  productLine,
  tab
}) => {
  return CaseStudiesConfig[productLine][tab];
};